import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-cart3-icon',
  templateUrl: './shopping-cart3.component.html'
})
export class ShoppingCart3Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
